export const joinValues = (values: Array<string | null | undefined>) => {
  return values.filter((value) => Boolean(value?.toString().trim())).join(" ");
};
